<template>
  <div class="foundation-name">
    <p class="foundation-name__cn">財團法人台灣早產兒基金會</p>
    <p class="foundation-name__en">PREMATURE BABY FOUNDATION OF TAIWAN</p>
  </div>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'FoundationName',
});
</script>
<style lang="scss" scoped>
.foundation-name {
  &__cn {
    @include font-style($c-white, 22, 500, 2.2px, 32px);
  }

  &__en {
    @include font-style($c-white, 18, 500, normal, 26px);
  }
}
</style>
